import React, { useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { mapStartupStatusToText } from "../../lib/map-startup-status-to-text";
import { updateProject } from "../../services/projectService";
import { Project } from "../../types/Project";
import { StartupStatus } from "../../types/StartupStatus";
import "./StartupStatusForm.scss";

export const StartupStatusOptions = Object.values(StartupStatus).filter(
  (status) => status !== StartupStatus.Unknown,
);
interface StartupStatusFormProps {
  project: Project;
}

const StartupStatusForm: React.FC<StartupStatusFormProps> = ({ project }) => {
  const [selectedStatuses, setSelectedStatuses] = useState<StartupStatus[]>(
    project.startupStatus ?? [],
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const handleCheckboxChange = (status: StartupStatus) => {
    setSelectedStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status],
    );
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      await updateProject(project.id, { startupStatus: selectedStatuses });
      setSuccessMessage("Status updated");
    } catch (err) {
      setError("Failed to update status. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="startup-status-form">
      <div className="form-header">Update Startup Status</div>
      {StartupStatusOptions.map((status) => (
        <div key={status} className="checkbox-group">
          <Form.Check
            type="checkbox"
            label={mapStartupStatusToText(status)}
            id={`status-${status}`}
            value={status}
            checked={selectedStatuses.includes(status)}
            onChange={() => handleCheckboxChange(status)}
            disabled={isLoading}
          />
        </div>
      ))}
      <Button variant="primary" type="submit" disabled={isLoading}>
        {isLoading ? "Updating..." : "Update Status"}
      </Button>
      {error && <Alert variant="danger">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
    </Form>
  );
};

export default StartupStatusForm;
